import { render, staticRenderFns } from "./MuxUploadPanel.vue?vue&type=template&id=4464cb1f&scoped=true"
import script from "./MuxUploadPanel.vue?vue&type=script&lang=js"
export * from "./MuxUploadPanel.vue?vue&type=script&lang=js"
import style0 from "./MuxUploadPanel.vue?vue&type=style&index=0&id=4464cb1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4464cb1f",
  null
  
)

export default component.exports